module.exports = __webpack_public_path__ + "img/ben-unsplash.d4502b51.jpg";